import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

const UPDATE_PARTIAL_USER_MUTATION = gql`
  mutation updatePartialUser($input: UpdatePartialUserInput!) {
    updatePartialUser(input: $input) {
      user {
        id
        phoneNumber
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export interface UpdatePartialUserInput {
  firstName: string
  lastName: string
  email: string
  countryCode: string
  phoneNumber: string
  password?: string
  terms: boolean
  smsTrackingOptinConfirmed: boolean
  hearAboutUs: string
  userId?: string
  orderId?: string
  trackingId?: string
}

interface UpdatePartialUserMutation {
  user: User
  success: boolean
  errors: MutationError[]
}

interface UpdateUserMutationResponse {
  updatePartialUser: UpdatePartialUserMutation
}

const useUpdatePartialUserApi = (): UseMutationResult<
  UpdatePartialUserMutation,
  Error,
  UpdatePartialUserInput,
  unknown
> => {
  const client = useGraphQLClient()

  const updatePartialUserApi = async (
    input: UpdatePartialUserInput,
  ): Promise<UpdatePartialUserMutation> => {
    const result = await client.request<UpdateUserMutationResponse>(UPDATE_PARTIAL_USER_MUTATION, {
      input,
    })

    return result.updatePartialUser
  }

  return useMutation<UpdatePartialUserMutation, Error, UpdatePartialUserInput>({
    mutationFn: updatePartialUserApi,
  })
}

export default useUpdatePartialUserApi
